export default (state, action) => {
  switch (action.type) {
    case 'GET_REPORT': {
      return {
        ...state,
        reports: action.payload.reports,
        orgReports: action.payload.orgReports,
        sharedReports: action.payload.sharedReports,
      };
    }
    case 'GET_SUB': {
      return {
        ...state,
        subscription: action.payload,
      };
    }
    case 'INCREMENT_LOADING': {
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.payload.type]: (state?.loading[action.payload.type] || 0) + 1,
        },
      };
    }
    case 'DECREMENT_LOADING': {
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.payload.type]:
            (state?.loading[action.payload.type] - 1 >= 0
              ? state?.loading[action.payload.type] - 1
              : 0) || 0,
        },
      };
    }
    case 'SET_LOADING': {
      return {
        ...state,
        loading: true,
      };
    }
    case 'FINISH_LOADING': {
      return {
        ...state,
        loading: false,
      };
    }
    case 'STORE_LINK': {
      return {
        ...state,
        link: action.payload.link,
        id: action.payload.id,
      };
    }
    case 'RESET_LINK': {
      return {
        ...state,
        link: null,
        id: null,
      };
    }
    case 'UPDATE_ORDER': {
      return {
        ...state,
        reports: action.payload,
      };
    }
    case 'SET_SUB': {
      return {
        ...state,
        subscription: action.payload,
      };
    }
    case 'SET_USERNAME': {
      return {
        ...state,
        userInfo: action.payload,
      };
    }
    case 'SET_INREPORT': {
      return {
        ...state,
        inReport: action.payload,
      };
    }

    case 'SET_TABS': {
      return {
        ...state,
        tabs: action.payload,
      };
    }

    case 'UPDATE_TABNAME': {
      return {
        ...state,
        tabs: action.payload,
      };
    }

    case 'DELETE_TAB': {
      return {
        ...state,
        tabs: state.tabs.filter((t) => t.key !== action.payload),
        activeTab: 0,
      };
    }

    case 'SET_ACTIVE_TAB': {
      return {
        ...state,
        activeTab: action.payload,
      };
    }

    default:
      return state;
  }
};
